/**
 * OTIS FERU Website - Main JavaScript
 * Coastal Professional Design
 */

// ============================================
// 1. DOM READY
// ============================================
document.addEventListener('DOMContentLoaded', () => {
  // Hide loader
  hideLoader();

  // Initialize all components
  initNavbar();
  initMobileMenu();
  initTypewriter();
  initScrollReveal();
  initPortfolioFilters();
  initPortfolioTouch();
  initModals();
  initSmoothScroll();
  initHeroGlow();
  initGlitchEffect();
  // initServiceCardGlitch();  // désactivé — remplacé par le nouveau hover CSS (numéro + lift + rotation icône) cohérent avec les cards IA
  initCustomCursor();
});

// ============================================
// 2. LOADER
// ============================================

function hideLoader() {
  const loader = document.getElementById('charg');
  if (loader) {
    setTimeout(() => {
      loader.classList.add('hidden');
      document.getElementById('page').style.display = 'block';
    }, 500);
  }
}

// ============================================
// 3. NAVBAR - GLASSMORPHISM ON SCROLL
// ============================================

function initNavbar() {
  const navbar = document.querySelector('.navbar');
  if (!navbar) return;

  const logoImg = navbar.querySelector('.navbar__logo img');
  const logoWhite = 'img/logo_white.png';
  const logoDefault = 'img/logo-ai.png';
  const scrollThreshold = 50;

  function handleScroll() {
    if (window.scrollY > scrollThreshold) {
      navbar.classList.add('scrolled');
      if (logoImg) logoImg.src = logoDefault;
    } else {
      navbar.classList.remove('scrolled');
      if (logoImg) logoImg.src = logoWhite;
    }
  }

  // Initial check
  handleScroll();

  // Listen to scroll
  window.addEventListener('scroll', handleScroll, { passive: true });
}

// ============================================
// 4. MOBILE MENU
// ============================================

function initMobileMenu() {
  const toggle = document.querySelector('.navbar__toggle');
  const menu = document.querySelector('.mobile-menu');
  const overlay = document.querySelector('.mobile-menu-overlay');
  const closeBtn = document.querySelector('.mobile-menu__close');
  const links = document.querySelectorAll('.mobile-menu__link');

  if (!toggle || !menu) return;

  function openMenu() {
    toggle.classList.add('active');
    menu.classList.add('active');
    if (overlay) overlay.classList.add('active');
    document.body.style.overflow = 'hidden';
  }

  function closeMenu() {
    toggle.classList.remove('active');
    menu.classList.remove('active');
    if (overlay) overlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  // Toggle menu (ouvrir/fermer)
  toggle.addEventListener('click', () => {
    if (menu.classList.contains('active')) {
      closeMenu();
    } else {
      openMenu();
    }
  });

  if (overlay) {
    overlay.addEventListener('click', closeMenu);
  }

  // Close menu when clicking a link
  links.forEach(link => {
    link.addEventListener('click', closeMenu);
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('active')) {
      closeMenu();
    }
  });
}

// ============================================
// 5. TYPEWRITER EFFECT
// ============================================

function initTypewriter() {
  const typewriterElement = document.querySelector('.hero__typewriter-text');
  if (!typewriterElement) return;

  const texts = ['WordPress', 'WooCommerce', 'PrestaShop', 'Laravel', 'Symfony', 'PHP'];
  let textIndex = 0;
  let charIndex = 0;
  let isDeleting = false;
  let isPaused = false;

  const typingSpeed = 100;
  const deletingSpeed = 50;
  const pauseDuration = 2000;

  function type() {
    const currentText = texts[textIndex];

    if (isPaused) {
      setTimeout(type, pauseDuration);
      isPaused = false;
      isDeleting = true;
      return;
    }

    if (isDeleting) {
      typewriterElement.innerHTML = currentText.substring(0, charIndex - 1) + '<span class="cursor"></span>';
      charIndex--;

      if (charIndex === 0) {
        isDeleting = false;
        textIndex = (textIndex + 1) % texts.length;
        setTimeout(type, 500);
        return;
      }
    } else {
      typewriterElement.innerHTML = currentText.substring(0, charIndex + 1) + '<span class="cursor"></span>';
      charIndex++;

      if (charIndex === currentText.length) {
        isPaused = true;
      }
    }

    const speed = isDeleting ? deletingSpeed : typingSpeed;
    setTimeout(type, speed);
  }

  // Start typewriter
  setTimeout(type, 1000);
}

// ============================================
// 6. SCROLL REVEAL ANIMATIONS
// ============================================

function initScrollReveal() {
  const revealElements = document.querySelectorAll('.reveal, .reveal-left, .reveal-right');

  if (revealElements.length === 0) return;

  const observerOptions = {
    root: null,
    rootMargin: '0px',
    threshold: 0.1
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.classList.add('revealed');
        // Optionally unobserve after reveal
        // observer.unobserve(entry.target);
      }
    });
  }, observerOptions);

  revealElements.forEach(element => {
    observer.observe(element);
  });
}

// ============================================
// 7. PORTFOLIO FILTERS
// ============================================

function initPortfolioFilters() {
  const filterButtons = document.querySelectorAll('.portfolio__filter');
  const portfolioCards = document.querySelectorAll('.portfolio-card');

  if (filterButtons.length === 0 || portfolioCards.length === 0) return;

  filterButtons.forEach(button => {
    button.addEventListener('click', () => {
      // Update active state
      filterButtons.forEach(btn => btn.classList.remove('active'));
      button.classList.add('active');

      const filter = button.dataset.filter;

      // Filter cards
      portfolioCards.forEach(card => {
        const category = card.dataset.category;

        if (filter === 'all' || category === filter) {
          card.style.display = 'block';
          setTimeout(() => {
            card.style.opacity = '1';
            card.style.transform = 'scale(1)';
          }, 50);
        } else {
          card.style.opacity = '0';
          card.style.transform = 'scale(0.8)';
          setTimeout(() => {
            card.style.display = 'none';
          }, 300);
        }
      });
    });
  });
}

// ============================================
// 8. PORTFOLIO TOUCH SUPPORT
// ============================================

function initPortfolioTouch() {
  const portfolioCards = document.querySelectorAll('.portfolio-card');
  if (portfolioCards.length === 0) return;

  let currentTouchedCard = null;
  let touchStartX = 0;
  let touchStartY = 0;
  let isTap = true;
  const TAP_THRESHOLD = 10; // pixels

  portfolioCards.forEach(card => {
    card.addEventListener('touchstart', (e) => {
      touchStartX = e.touches[0].clientX;
      touchStartY = e.touches[0].clientY;
      isTap = true;
    }, { passive: true }); // passive: true to allow native scroll

    card.addEventListener('touchmove', (e) => {
      const deltaX = Math.abs(e.touches[0].clientX - touchStartX);
      const deltaY = Math.abs(e.touches[0].clientY - touchStartY);
      if (deltaX > TAP_THRESHOLD || deltaY > TAP_THRESHOLD) {
        isTap = false; // It's a scroll, not a tap
      }
    }, { passive: true });

    card.addEventListener('touchend', (e) => {
      if (!isTap) return; // It was a scroll, ignore

      // If another card is touched, remove its class
      if (currentTouchedCard && currentTouchedCard !== card) {
        currentTouchedCard.classList.remove('touched');
      }

      if (card.classList.contains('touched')) {
        // Second tap - open the link
        const link = card.querySelector('.portfolio-card__link');
        if (link) {
          window.open(link.href, '_blank');
        }
      } else {
        // First tap - show overlay
        card.classList.add('touched');
        currentTouchedCard = card;
      }
    });
  });

  // Remove touched class when tapping outside
  document.addEventListener('touchend', (e) => {
    if (currentTouchedCard && !currentTouchedCard.contains(e.target)) {
      currentTouchedCard.classList.remove('touched');
      currentTouchedCard = null;
    }
  });
}

// ============================================
// 9. MODALS
// ============================================

function initModals() {
  const modalTriggers = document.querySelectorAll('[data-modal]');
  const modals = document.querySelectorAll('.modal');
  const closeButtons = document.querySelectorAll('.modal__close');

  function openModal(modalId) {
    const modal = document.getElementById(modalId);
    if (modal) {
      modal.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  }

  function closeModal(modal) {
    modal.classList.remove('active');
    document.body.style.overflow = '';
  }

  function closeAllModals() {
    modals.forEach(modal => closeModal(modal));
  }

  // Open modal on trigger click
  modalTriggers.forEach(trigger => {
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      const modalId = trigger.dataset.modal;
      openModal(modalId);
    });
  });

  // Close modal on close button click
  closeButtons.forEach(button => {
    button.addEventListener('click', () => {
      const modal = button.closest('.modal');
      if (modal) closeModal(modal);
    });
  });

  // Close modal on overlay click
  modals.forEach(modal => {
    const overlay = modal.querySelector('.modal__overlay');
    if (overlay) {
      overlay.addEventListener('click', () => closeModal(modal));
    }
  });

  // Close on escape key
  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeAllModals();
    }
  });
}

// ============================================
// 10. SMOOTH SCROLL
// ============================================

function initSmoothScroll() {
  const scrollLinks = document.querySelectorAll('a[href^="#"]');

  scrollLinks.forEach(link => {
    link.addEventListener('click', (e) => {
      const href = link.getAttribute('href');

      // Skip if it's just "#" or a modal trigger
      if (href === '#' || link.hasAttribute('data-modal')) return;

      const target = document.querySelector(href);
      if (target) {
        e.preventDefault();

        const navbarHeight = document.querySelector('.navbar')?.offsetHeight || 0;
        const targetPosition = target.getBoundingClientRect().top + window.pageYOffset - navbarHeight;

        window.scrollTo({
          top: targetPosition,
          behavior: 'smooth'
        });
      }
    });
  });
}

// ============================================
// 11. HERO GLOW - MOUVEMENT + BATTEMENT + GLITCH COLLISION
// ============================================

function initHeroGlow() {
  const hero = document.querySelector('.hero');
  const titleSpan = document.querySelector('.hero__title span');
  if (!hero) return;

  // Créer l'élément glow
  const glow = document.createElement('div');
  glow.classList.add('hero__glow');
  hero.insertBefore(glow, hero.firstChild);

  // Partir du haut-gauche, descendre vers le titre, puis mouvement libre
  const isMobile = window.innerWidth <= 768;

  let moveTime = 0;
  let wasColliding = false;
  let lastTime = performance.now();
  let glitchTriggered = false;

  // Position de départ (haut gauche)
  const startX = 15;
  const startY = 10;
  // Position du titre (centre, légèrement plus haut sur mobile)
  const titleX = 50;
  const titleY = isMobile ? 28 : 35;

  // Fonction battement de coeur réaliste : boum-boum...boum-boum...
  function heartbeat(seconds) {
    const cycle = (seconds % 1);
    let beat = 0;

    if (cycle < 0.08) {
      beat = Math.sin(cycle * Math.PI / 0.08);
    } else if (cycle > 0.12 && cycle < 0.20) {
      beat = Math.sin((cycle - 0.12) * Math.PI / 0.08) * 0.6;
    }

    return Math.max(0, beat);
  }

  // Vérifier collision entre halo et titre
  function checkCollision(glowX, glowY) {
    if (!titleSpan) return false;

    const heroRect = hero.getBoundingClientRect();
    const titleRect = titleSpan.getBoundingClientRect();

    // Position du centre du halo en pixels
    const glowCenterX = heroRect.left + (glowX / 100) * heroRect.width;
    const glowCenterY = heroRect.top + (glowY / 100) * heroRect.height;

    // Rayon responsive selon la taille d'écran
    let glowRadius = 250; // Desktop
    if (window.innerWidth <= 768) {
      glowRadius = 100; // Mobile
    } else if (window.innerWidth <= 992) {
      glowRadius = 150; // Tablet
    }

    // Centre du titre
    const titleCenterX = titleRect.left + titleRect.width / 2;
    const titleCenterY = titleRect.top + titleRect.height / 2;

    // Distance entre les centres
    const distance = Math.hypot(glowCenterX - titleCenterX, glowCenterY - titleCenterY);

    // Collision si distance < rayon du halo
    return distance < glowRadius;
  }

  function animate() {
    const now = performance.now();
    const elapsed = (now - lastTime) / 1000;
    lastTime = now;

    moveTime += elapsed * 0.5;

    let x, y;

    if (moveTime < 1) {
      // Phase 1: aller vers le titre (1 seconde)
      const progress = moveTime;
      x = startX + (titleX - startX) * progress;
      y = startY + (titleY - startY) * progress;

    } else {
      // Phase 2: transition vers mouvement sinusoïdal
      const freeTime = moveTime - 1;

      // Position sinusoïdale
      const sinX = 50 + Math.sin(freeTime) * 25 + Math.sin(freeTime * 0.7) * 15;
      const sinY = 50 + Math.cos(freeTime * 0.8) * 20 + Math.cos(freeTime * 0.5) * 10;

      // Transition douce depuis le titre (2 secondes)
      const blend = Math.min(1, freeTime / 2);
      x = titleX + (sinX - titleX) * blend;
      y = titleY + (sinY - titleY) * blend;
    }

    // Battement
    const beat = heartbeat(now / 1000);
    const scale = 1 + beat * 0.2;
    const opacity = 0.6 + beat * 0.4;

    glow.style.left = x + '%';
    glow.style.top = y + '%';
    glow.style.transform = `translate(-50%, -50%) scale(${scale})`;
    glow.style.opacity = opacity;

    // Vérifier collision et déclencher glitch
    const isColliding = checkCollision(x, y);
    if (isColliding && !wasColliding && window.triggerGlitch) {
      window.triggerGlitch();
    }
    wasColliding = isColliding;

    requestAnimationFrame(animate);
  }

  requestAnimationFrame(animate);
}

// ============================================
// 12. GLITCH EFFECT (SVG DISTORTION)
// ============================================

function initGlitchEffect() {
  // Créer le filtre SVG (toujours, même sans hero)
  const svgNS = 'http://www.w3.org/2000/svg';
  const svg = document.createElementNS(svgNS, 'svg');
  svg.setAttribute('style', 'position: absolute; width: 0; height: 0;');
  svg.innerHTML = `
    <defs>
      <filter id="glitch-filter">
        <feTurbulence type="fractalNoise" baseFrequency="0.02" numOctaves="3" result="noise" seed="0"/>
        <feDisplacementMap in="SourceGraphic" in2="noise" scale="20" xChannelSelector="R" yChannelSelector="G"/>
      </filter>
    </defs>
  `;
  document.body.appendChild(svg);

  const turbulence = svg.querySelector('feTurbulence');
  let glitchCount = 0; // Compteur d'éléments en glitch
  let seed = 0;
  let animationRunning = false;

  // Animation du glitch (partagée par tous les éléments)
  function animateGlitch() {
    if (glitchCount <= 0) {
      animationRunning = false;
      return;
    }

    seed += 1;
    turbulence.setAttribute('seed', seed);
    requestAnimationFrame(animateGlitch);
  }

  // Démarrer l'animation si pas déjà en cours
  function startAnimation() {
    if (!animationRunning) {
      animationRunning = true;
      animateGlitch();
    }
  }

  // Fonction globale pour déclencher le glitch sur un élément
  window.triggerGlitchOn = function(element, duration) {
    if (!element || element.classList.contains('glitching')) return;

    glitchCount++;
    element.classList.add('glitching');
    startAnimation();

    // Durée du glitch : 400-600ms par défaut
    const glitchDuration = duration || (400 + Math.random() * 200);

    setTimeout(() => {
      glitchCount--;
      element.classList.remove('glitching');
    }, glitchDuration);
  };

  // Fonction legacy pour le hero title (utilisée par initHeroGlow)
  const titleSpan = document.querySelector('.hero__title span');
  window.triggerGlitch = function() {
    if (titleSpan) {
      window.triggerGlitchOn(titleSpan);
    }
  };
}

// ============================================
// 13. SERVICE CARD GLITCH ON HOVER
// ============================================

function initServiceCardGlitch() {
  const serviceCards = document.querySelectorAll('.service-card');
  if (serviceCards.length === 0) return;

  serviceCards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      if (window.triggerGlitchOn) {
        window.triggerGlitchOn(card);
      }
    });
  });
}

// ============================================
// 14. UTILITY FUNCTIONS
// ============================================

// Debounce function for performance
function debounce(func, wait = 20) {
  let timeout;
  return function executedFunction(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

// Throttle function for scroll events
function throttle(func, limit = 100) {
  let inThrottle;
  return function executedFunction(...args) {
    if (!inThrottle) {
      func(...args);
      inThrottle = true;
      setTimeout(() => inThrottle = false, limit);
    }
  };
}

// ============================================
// 15. CUSTOM CURSOR & TOUCH RIPPLE
// ============================================

function initCustomCursor() {
  const cursor = document.getElementById('cursor');

  // Vérifier si c'est un appareil tactile
  const isTouchDevice = ('ontouchstart' in window) || (navigator.maxTouchPoints > 0);

  if (!isTouchDevice) {
    // Desktop : curseur personnalisé
    if (cursor) {
      document.addEventListener('mousemove', (e) => {
        cursor.style.left = e.clientX + 'px';
        cursor.style.top = e.clientY + 'px';
      });

      document.addEventListener('mouseleave', () => {
        cursor.style.display = 'none';
      });

      document.addEventListener('mouseenter', () => {
        cursor.style.display = 'block';
      });
    }
  } else {
    // Mobile : cacher le curseur et effet ripple au toucher
    if (cursor) {
      cursor.style.display = 'none';
    }

    document.addEventListener('touchstart', (e) => {
      const touch = e.touches[0];
      createRipple(touch.clientX, touch.clientY);
    }, { passive: true });
  }
}

// Créer l'effet ripple (goutte d'eau)
function createRipple(x, y) {
  const ripple = document.createElement('div');
  ripple.className = 'touch-ripple';
  ripple.style.left = x + 'px';
  ripple.style.top = y + 'px';
  ripple.style.width = '150px';
  ripple.style.height = '150px';
  document.body.appendChild(ripple);

  // Supprimer après l'animation
  ripple.addEventListener('animationend', () => {
    ripple.remove();
  });
}
